/* @flow */
import * as React from 'react';

import NavigationListGroupItem from './NavigationListGroupItem.jsx';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import * as GroupPromises from 'groups/lib/GroupPromises.js';

type Props = {
  group: *,
};

type State = {
  district: ?Organization,
};

export default class NavigationListDistrictGroupItem extends React.Component<Props, State> {
  state = {
    district: null,
  };

  async componentDidMount() {
    const districtGroup = await GroupPromises.loadGroupByCode(this.props.group.name);
    if (districtGroup) {
      this.setDistrict(districtGroup);
    }
  }

  setDistrict = (group: Group) => {
    this.setState({ district: group.getOrganization() });
  };

  render() {
    return <NavigationListGroupItem group={this.props.group} district={this.state.district} />;
  }
}
